import styled, { css } from 'styled-components';
import { action } from '@storybook/addon-actions';

import {
  createUID,
  defaultThemeProp,
  type FileDisplayProps,
  type LightboxProps
} from '@pega/cosmos-react-core';
import type { GenAIMessageProps, UserMessageProps, MessageProps } from '@pega/cosmos-react-work';

export const coachOptionsMock = [
  {
    id: createUID(),
    primary: 'Pega GenAI™ Coach',
    secondary: ['Description'],
    selected: true
  },
  {
    id: createUID(),
    primary: 'Pega GenAI™ Coach 2',
    secondary: ['Description'],
    selected: false
  },
  {
    id: createUID(),
    primary: 'Pega GenAI™ Coach 3',
    secondary: ['Description'],
    selected: false
  }
];

export const genAICoachMessageMockData: GenAIMessageProps[] = [
  {
    from: 'coach',
    id: createUID(),
    coachName: 'Pega Gen AI™ coach',
    message:
      'Good morning **Captain**. Welcome to the claims management application. I see there is a new claim by Natalie portman to process today. Shall we process?',
    suggestions: [
      {
        id: createUID(),
        message: 'How can I close this task?'
      },
      {
        id: createUID(),
        message: 'How can I create a case?'
      },
      {
        id: createUID(),
        message: 'How can I extend an application to mobile channel?'
      },
      {
        id: createUID(),
        message: "What's the process of establishing a REST connection?"
      }
    ],
    onSend: ({ id, message }) => {
      action(': message')(message, id);
    }
  },
  {
    from: 'coach',
    id: createUID(),
    coachName: 'Pega Gen AI™ coach',
    message:
      'Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers. Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers. Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers. Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers. Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers. Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers. Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers. Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers. Certainly! Here are the detailed steps for the sales team to focus on over the next week:\n\n1. **Identify Competition:** - Research Competitors: Conduct thorough research to identify the main competitors in the market offering similar Business Voice over IP (VoIP) solutions. This could involve using industry reports, online resources, and competitor analysis tools.\n 2. **Engage with the Client:**\n Schedule a meeting with the key contacts at Seagate to discuss their specific requirements and preferences for the Business Voice over IP (VoIP) solution. This meeting could be conducted in person or virtually, depending on the client availability.\n 3. **Determine the Sales Team:** \n Determine the key stakeholders within the sales team who will be involved in the proposal development and decision-making process. This could include sales representatives, solution architects, and sales managers.',
    suggestions: [
      {
        id: createUID(),
        message: 'How can I close this task?'
      },
      {
        id: createUID(),
        message: 'How can I create a case?'
      },
      {
        id: createUID(),
        message: 'How can I extend an application to mobile channel?'
      },
      {
        id: createUID(),
        message: "What's the process of establishing a REST connection?"
      }
    ]
  },
  {
    from: 'user',
    id: 'user_message',
    message: 'How can I initiate an **email conversation**?'
  }
];

export const StyledCoachList = styled.ul(({ theme }) => {
  return css`
    width: 25rem;
    background-color: ${theme.base.palette['primary-background']};
    padding: ${theme.base.spacing};
    list-style-type: none;
  `;
});

StyledCoachList.defaultProps = defaultThemeProp;

export const userMessageMockData: UserMessageProps = {
  from: 'user',
  id: 'user message',
  message: 'How do I create a phone interaction?'
};

export const initialSuggestedMessagesMockData: MessageProps[] = [
  {
    id: createUID(),
    message: 'What are the different types of rules instances?'
  },
  {
    id: createUID(),
    message: 'What are the different types of rules instances?'
  },
  {
    id: createUID(),
    message: 'What are the different types of rules instances?'
  },
  {
    id: createUID(),
    message: 'What are the different types of rules instances?'
  }
];

export const suggestionsMock = [
  {
    id: 'Agent suggestions',
    label: 'Agent suggestions',
    items: [
      {
        id: createUID(),
        primary: 'How well is the team following the sales methodology?'
      },
      {
        id: createUID(),
        primary: 'Are there any risks with this opportunity?​'
      },
      {
        id: createUID(),
        primary: 'How can I help the team progress this deal?​'
      }
    ]
  }
];

export const StyledContainer = styled.div<{ fullPageView?: boolean }>(({ fullPageView }) => {
  const width = fullPageView ? '50rem' : '25rem';
  return css`
    width: ${width};
  `;
});

export const conversationHistorySummaryData = [
  {
    section: 'Today',
    id: '1',
    conversations: [
      {
        id: '1-1',
        title: 'Project Discussion'
      },
      {
        id: '1-2',
        title: 'Brainstorming Session'
      }
    ]
  },
  {
    id: '2',
    section: 'Previous 7 Days',
    conversations: [
      {
        id: '2-1',
        title: 'Team Standup Notes'
      }
    ]
  },
  {
    id: '3',
    section: 'Previous 30 Days',
    conversations: [
      {
        id: '3-1',
        title: 'REST API Integration Experience'
      },
      {
        id: '3-2',
        title: 'Important Meeting Notes'
      },
      {
        id: '3-3',
        title: 'Client Requirements'
      },
      {
        id: '3-4',
        title: 'Old Project Discussion'
      },
      {
        id: '3-5',
        title: 'CI/CD Pipeline Setup'
      },
      {
        id: '3-6',
        title: 'Retrospective Notes'
      },
      {
        id: '3-7',
        title: 'Source Maps in Bundling'
      }
    ]
  },
  {
    id: '4',
    section: 'Previous 30 Days',
    conversations: [
      {
        id: '4-1',
        title: 'Ideas for Next Project'
      },
      {
        id: '4-2',
        title: 'Bookmarked Articles'
      },
      {
        id: '4-3',
        title: 'Feature Requests'
      },
      {
        id: '4-4',
        title: 'Color Palette Finalization'
      },
      {
        id: '4-5',
        title: 'React CodeMirror Integration'
      },
      {
        id: '4-7',
        title: 'Source Maps in Bundling'
      }
    ]
  }
];

export const attachmentsMock: FileDisplayProps[] = [
  {
    id: createUID(),
    displayText: 'file.txt',
    value: 'file.txt',
    variant: 'file',
    onPreview: action('File previewed')
  }
];

export const attachmentsPreviewMock: LightboxProps = {
  items: [
    {
      id: '1',
      name: 'pega.jpg',
      description: 'Descriptive text about File 1',
      format: 'jpg',
      src: 'https://www.pega.com/themes/custom/pegawww_theme/images/pega-logo.svg'
    }
  ],
  cycle: true,
  onAfterClose: action('Preview closed'),
  onItemDownload: action('File downloaded')
};
